import { IconBike16, IconBus16, IconCompetitor16, IconMetroMsk16, IconParking16, IconWalk16 } from '@cian/ui-kit';

import { IconScooter16 } from '../../../../../components/IconScooter16';
import { IconStreetCar16 } from '../../../../../components/IconStreetCar16';
import { IMapRowsProps } from '../../../../../components/Map/parts/MapRows';
import { EOutsideTAInfrastructureType, ITAInfrastructure } from '../../../../../types/map';
import { getAvailableOutsideInfrastructureTypes } from '../../../helpers/transportAccessibility';

const INFRASTRUCTURE_TYPES: Record<
  EOutsideTAInfrastructureType,
  {
    text: string;
    IconComponent: React.FunctionComponent;
  }
> = {
  [EOutsideTAInfrastructureType.busStops]: {
    text: 'Автобусы',
    IconComponent: IconBus16,
  },
  [EOutsideTAInfrastructureType.tramStops]: {
    text: 'Трамваи',
    IconComponent: IconStreetCar16,
  },
  [EOutsideTAInfrastructureType.metro]: {
    text: 'Метро',
    IconComponent: IconMetroMsk16,
  },
  [EOutsideTAInfrastructureType.parking]: {
    text: 'Парковки',
    IconComponent: IconParking16,
  },
  [EOutsideTAInfrastructureType.bikeParking]: {
    text: 'Велопарковки',
    IconComponent: IconBike16,
  },
  [EOutsideTAInfrastructureType.chargingStations]: {
    text: 'Станции зарядки электромобилей',
    IconComponent: IconCompetitor16,
  },
  [EOutsideTAInfrastructureType.scooterParking]: {
    text: 'Парковки для самокатов',
    IconComponent: IconScooter16,
  },
  [EOutsideTAInfrastructureType.boulevards]: {
    text: 'Пешеходные бульвары',
    IconComponent: IconWalk16,
  },
};

export const getOutsideRows = (
  transportAccessibilityInfrastructure: ITAInfrastructure | undefined,
): IMapRowsProps['items'] => {
  const availableInfrastructureTypes = getAvailableOutsideInfrastructureTypes(transportAccessibilityInfrastructure);

  return availableInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPES[type],
  }));
};
